import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import { OrderULResponse } from '@cemex-core/cmx-api';
import { SimulateULActions, SimulateULActionTypes } from './simulate-ul.actions';

export interface ISimulateULState {
  loading: boolean;
  simulateULResponse: OrderULResponse;
}

export const initialState: ISimulateULState = {
  loading: false,
  simulateULResponse: null,
};

export function simulateUlReducer(
  state = initialState,
  action: SimulateULActions | OrderBuilderActions,
): ISimulateULState {
  switch (action.type) {
    case SimulateULActionTypes.LOAD: {
      return {
        ...state,
        ...initialState,
        loading: true,
      } as ISimulateULState;
    }
    case SimulateULActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        simulateULResponse: action.payload,
      } as ISimulateULState;
    }
    case RESET_BUILDER:
    case SimulateULActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
